import HttpClient from '../utility/http-client';

export default {
    cartList(page: number, rowPerPage: number, q: any) {
        const url = `/api/cart/?page=${page}&rowsPerPage=${rowPerPage}&q=${q}`;
        return HttpClient.instance().get(url);
    },

    cartByIds(ids: string) {
        const url = `/api/cart/?ids=${ids}`;
        return HttpClient.instance().get(url);
    },

    cartEdit(dataRequest: any, cartId: number) {
        const url = `/api/cart/${cartId}`;
        return HttpClient.instance().post(url, dataRequest);
    },

    cartAddItem(item: any) {
        const url = `/api/cart/`;
        return HttpClient.instance().put(url, item);
    },

    cartRemoveItem(itemId: number) {
        const url = `/api/cart_detail/${itemId}`;
        return HttpClient.instance().delete(url);
    },

    cartRemoveProducts(itemIds: number[]) {
        const url = `/api/cart_detail/`;
        return HttpClient.instance().post(url, { 'ids': itemIds });
    },

    cartRemoveCarts(itemIds: number[]) {
        const url = `/api/cart/`;
        return HttpClient.instance().post(url, { 'ids': itemIds });
    },

    cartRemove(cartId: number) {
        const url = `/api/cart/${cartId}`;
        return HttpClient.instance().delete(url);
    },

    cartConfirm(itemIds: number[], otherOptions: any) {
        const url = `/api/confirm_order/`;
        return HttpClient.instance().post(url, { 'Products': itemIds, 'OtherOptions': otherOptions });
    },

    bulk_action(itemIds: number[], otherOptions: any, isDeposit: boolean, chinaStoreID, receivePlaceID) {
        const url = `/api/bulk_action/`;
        return HttpClient.instance().post(url, { 'ActionType': 'cart-deposit', 'IsDeposit': isDeposit, 'Products': itemIds,  'OtherOptions': otherOptions, 'ChinaStoreID': chinaStoreID, 'ReceivePlaceID': receivePlaceID});
    },

    finishCart(dataRequest: any) {
        const url = `/api/main_order/`;
        return HttpClient.instance().put(url, dataRequest);
    },

    searchProducts(siteName: string, searchTerm: string, isMobile: boolean) {
        const url = `/api/taobao_search/?term=${searchTerm}&site=${siteName}&mobile=${isMobile ? 1 : 0}`;
        return HttpClient.instance().get(url);
    },

    listProducts() {
        const url = `/api/taobao_products/`;
        return HttpClient.instance().get(url);
    },

    detailProduct(siteURL: string) {
        const url = `/api/taobao_product_detail/?url=${siteURL}`;
        return HttpClient.instance().get(url);
    },

    searchProductsByKeyword(keyword: string, platform: string = 'taobao', page: number = 1, pageSize: number = 20) {
        const url = `/api/elim_search/?keyword=${encodeURIComponent(keyword)}&platform=${platform}&page=${page}&pageSize=${pageSize}`;
        return HttpClient.instance().get(url);
    },

    uploadImageForSearch(file: File) {
        const formData = new FormData();
        formData.append('image', file);
        const url = `/api/elim_upload_image/`;
        return HttpClient.instance().post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    uploadImageAndSearch(file: File, platform: string = 'taobao', page: number = 1, pageSize: number = 20) {
        const formData = new FormData();
        formData.append('image', file);
        formData.append('platform', platform);
        formData.append('page', page.toString());
        formData.append('pageSize', pageSize.toString());
        const url = `/api/elim_upload_and_search/`;
        return HttpClient.instance().post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    searchProductsByImageUrl(imgUrl: string, platform: string = 'taobao', page: number = 1, pageSize: number = 20) {
        const url = `/api/elim_search_image_url/?img_url=${encodeURIComponent(imgUrl)}&platform=${platform}&page=${page}&pageSize=${pageSize}`;
        return HttpClient.instance().get(url);
    },

    searchProductsByImageId(imgId: string, platform: string = 'taobao', page: number = 1, pageSize: number = 20) {
        const url = `/api/elim_search_image_id/?img_id=${encodeURIComponent(imgId)}&platform=${platform}&page=${page}&pageSize=${pageSize}`;
        return HttpClient.instance().get(url);
    },
};
